import {type MutationTree} from 'vuex';

const mutations: MutationTree<ModuleShiftScheduleState> = {
};

export default mutations;